module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header-ef2daa3fde59d8ea09a853727e29864a.webp";